export enum PromptEvent {
  promptClick = 'prompt-click',
  promptDismissed = 'prompt-dismissed',
  promptShow = 'prompt-show',
}
